<div
  class="fare-family-option rounded-large white-bg flex flex--column grow border relative"
  [style.outline-color]="extendedFareFamily.selected ? extendedFareFamily.benefits.brandColor : ''"
  [ngClass]="{
    selected: extendedFareFamily.selected
  }"
>
  <div
    class="absolute badge z1"
    *ngIf="
      extendedFareFamily.badgeType === FareFamilyBadgeType.POPULAR ||
      extendedFareFamily.badgeType === FareFamilyBadgeType.NEW
    "
  >
    <div
      class="badge-content font-body-2 white-text medium-type ps-xxsmall-y ps-xsmall-x relative"
      [ngClass]="{
        popular: extendedFareFamily.badgeType === FareFamilyBadgeType.POPULAR,
        new: extendedFareFamily.badgeType === FareFamilyBadgeType.NEW,
        'heather-700-bg': extendedFareFamily.badgeType === FareFamilyBadgeType.POPULAR && !extendedFareFamily.selected,
        'heather-700-text': extendedFareFamily.badgeType === FareFamilyBadgeType.POPULAR && extendedFareFamily.selected,
        'nordic-blue-900-bg': extendedFareFamily.badgeType === FareFamilyBadgeType.NEW && !extendedFareFamily.selected,
        'nordic-blue-900-text': extendedFareFamily.badgeType === FareFamilyBadgeType.NEW && extendedFareFamily.selected,
        'white-bg': extendedFareFamily.selected
      }"
    >
      <ng-container *ngIf="extendedFareFamily.badgeType === FareFamilyBadgeType.POPULAR">{{
        'ticketSelection.fareFamily.ribbonText' | finLocalization
      }}</ng-container>
      <ng-container *ngIf="extendedFareFamily.badgeType === FareFamilyBadgeType.NEW">{{
        'booking.newFareFamilyLabel' | finLocalization
      }}</ng-container>
    </div>
  </div>
  <button
    class="fare-header border-bottom overflow-hidden rounded-top-large flex--column flex--align-stretch relative"
    [style.--hover-color]="extendedFareFamily.benefits.brandColor"
    [ngClass]="{ 'nordic-blue-25-bg': !extendedFareFamily.selected }"
    [style.background-color]="extendedFareFamily.selected ? extendedFareFamily.benefits.brandColor : ''"
    (click)="handleSelectFareFamilyClick($event, extendedFareFamily)"
    data-test-fare-family-option-select-button
  >
    <div class="flex flex--column ps-small">
      <fcom-icon
        class="icon-medium circle"
        [ngClass]="{
          'border white-border nordic-blue-900-bg white-text selected': extendedFareFamily.selected,
          'nordic-blue-900-border white-bg': !extendedFareFamily.selected
        }"
        category="svg-library"
        name="{{ extendedFareFamily.selected ? 'checkmark' : 'radiobutton-unselected' }}"
      >
      </fcom-icon>
      <div class="flex flex--column ms-xsmall-t">
        <span
          class="font-body-1 medium-type align-left brand-name"
          [ngClass]="extendedFareFamily.selected ? 'white-text' : 'nordic-blue-900-text'"
        >
          {{ extendedFareFamily.benefits.brandName }}</span
        >
        <div
          class="fare-family-option-price align-left"
          [ngClass]="{
            'font-heading-3': !extendedFareFamily.points,
            'font-heading-4': extendedFareFamily.points
          }"
        >
          <span
            class="bold-type"
            [ngClass]="
              extendedFareFamily.selected
                ? 'white-text'
                : hasSpecialOffer || extendedFareFamily.originalPrice
                  ? 'heather-700-text'
                  : 'blue-900-text'
            "
          >
            <span *ngIf="extendedFareFamily.points"
              >{{
                'award.points' | finLocalization: { pointsAmount: +extendedFareFamily.points || 0 | finPoints }
              }}
              +</span
            >
            {{ extendedFareFamily.price | finToObservable | finOffersPrice: currencyCode$ | async }}
          </span>
          <span
            *ngIf="extendedFareFamily.originalPrice"
            [ngClass]="!extendedFareFamily.selected ? 'nordic-blue-900-text' : 'white-text'"
            class="font-body-2 ps-xsmall-l strike-through"
            data-test-fare-family-original-price
          >
            {{ extendedFareFamily.originalPrice | finToObservable | finOffersPrice: currencyCode$ | async }}
          </span>
        </div>
      </div>
    </div>
    <div
      [style]="{ 'background-color': extendedFareFamily.benefits.brandColor }"
      class="top-border absolute fill"
    ></div>
  </button>

  <div class="flex flex--column flex-1">
    <div
      *ngIf="extendedFareFamily.benefits.brandNameDescription"
      class="punchline flex--basis80 ps-small-x ps-small-t"
      [ngClass]="(isMobile$ | async) === true ? 'font-body-1' : 'font-body-2'"
    >
      {{ extendedFareFamily.benefits.brandNameDescription }}
    </div>
    <div
      class="mr-small-t"
      [ngClass]="{ 'border-top-dashed': (isMobile$ | async) === false }"
      *ngIf="!extendedFareFamily.totalAviosAccrual || !enableLoyaltyAvios"
      data-test-empty-punchline-space
    ></div>
    <ng-container *ngIf="extendedFareFamily.totalAviosAccrual && enableLoyaltyAvios">
      <fcom-chip class="ms-small-l">
        <fcom-icon [name]="'avios-plectrum'" class="ms-xxsmall-r icon-small"></fcom-icon>
        <span>
          {{
            'avios.collectPointsTag'
              | finLocalization: { points: extendedFareFamily.totalAviosAccrual?.toLocaleString() }
          }}
        </span>
      </fcom-chip>
    </ng-container>
    <fin-expand
      [id]="'benefit-accordion'"
      class="flex flex--column flex-1"
      [key]="accordionId"
      [expandContentClass]="'flex flex-1'"
      [expandContainerClass]="'flex flex-1'"
      #expand
      *ngIf="(isMobile$ | async) === true"
      (expandOpen)="toggleExpand($event)"
    >
      <div class="trigger flex nordic-blue-900-text font-body-1 medium-type underline">
        <div class="ps-small-x">
          <ng-container *ngIf="expandOpen">
            {{ 'ticketSelection.hideDetails' | finLocalization }}
          </ng-container>
          <ng-container *ngIf="!expandOpen">
            {{ 'ticketSelection.showDetails' | finLocalization }}
          </ng-container>
        </div>
        <div class="ps-xxsmall-l flex-1 flex--nogrow flex--self-start ps-small-x">
          <fcom-icon name="chevron-down" class="rotate icon-medium" [class.rotate-active]="expandOpen"></fcom-icon>
        </div>
      </div>
      <div class="content border-top-dashed ms-small-t flex flex--column">
        <div class="benefits-list flex-1 benefits">
          <fin-benefit
            class="block ps-small-x ps-xxsmall-y"
            *ngFor="let benefit of highlightedBenefits"
            [benefit]="benefit"
          ></fin-benefit>
        </div>
        <ng-container [ngTemplateOutlet]="detailsNotification"></ng-container>
      </div>
    </fin-expand>

    <ng-container *ngIf="(isMobile$ | async) === false">
      <div class="flex-1 benefits">
        <fin-benefit
          class="block ps-small-x ps-xxsmall-y"
          *ngFor="let benefit of highlightedBenefits"
          [benefit]="benefit"
        ></fin-benefit>
      </div>
      <ng-container [ngTemplateOutlet]="detailsNotification"></ng-container>
    </ng-container>
  </div>

  <ng-template #detailsNotification>
    <fcom-notification
      class="details-notification"
      [theme]="NotificationTheme.INFO"
      [iconName]="IconName.INFO_OUTLINE"
      [iconCategory]="'svg-library'"
      [contentSpaceClass]="NotificationContentSpaceClass.PS_XSMALL"
      [borderDirection]="NotificationBorderDirection.ROUNDED_BOTTOM_LARGE"
    >
      <span class="font-body-2 underline link-hover" (click)="handleShowDetails(extendedFareFamily)">
        {{ 'ticketSelection.dimensionsAndDetails' | finLocalization }}
      </span>
    </fcom-notification>
  </ng-template>
</div>
